import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { UserPlus, Share2, Wallet, Handshake, ChevronDown } from "lucide-react";
import { Chapter } from "./Reveal";

const STEPS = [
  { icon: UserPlus, title: "Registrati gratis", text: "Crei il tuo profilo partner in 2 minuti e ricevi il tuo codice personale." },
  { icon: Share2, title: "Condividi il codice", text: "Lo giri ad attività che conosci: negozi, professionisti, ristoranti." },
  { icon: Wallet, title: "Guadagni 97€ a vendita", text: "Per ogni abbonamento attivato col tuo codice, 97€ arrivano direttamente a te." },
];

export const Partner = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="partner" data-testid="partner-section" className="mx-auto max-w-6xl px-5 py-12">
      <Chapter number="05" label="Diventa partner" />
      <button
        type="button"
        data-testid="partner-toggle-btn"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="mx-auto flex w-full max-w-3xl flex-col items-center gap-3 rounded-3xl bg-gradient-to-br from-[#49324D] to-[#5d4062] px-6 py-7 text-center shadow-lg shadow-purple-900/25 ring-1 ring-purple-300/40 transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-purple-900/35"
      >
        <span className="rounded-full bg-white/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-purple-100">
          Programma partner
        </span>
        <span className="font-heading text-xl font-bold leading-snug text-white sm:text-2xl">
          Diventa partner di MirIA <span className="text-purple-200">a costo zero e guadagna</span>
        </span>
        <ChevronDown
          className={`h-6 w-6 text-purple-200 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
        />
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="partner-content"
            data-testid="partner-content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden"
          >
            <p className="mx-auto mt-6 max-w-2xl text-center text-base text-slate-600">
              Conosci un'attività che ha bisogno di marketing? Girale il tuo codice e guadagna{" "}
              <strong className="text-slate-900">97€ per ogni abbonamento attivato</strong>. Niente da comprare,
              niente quote: solo il tuo codice.
            </p>

            <div className="mx-auto mt-6 max-w-xl">
              <div
                data-testid="partner-case-0"
                className="h-full rounded-3xl border border-purple-100 bg-white p-6 text-center shadow-sm"
              >
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-2xl bg-purple-100">
                  <Handshake className="h-5 w-5 text-purple-600" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-slate-900">
                  Non hai un'attività, ma ne conosci una?
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  Il profilo partner è a costo zero: niente abbonamento, niente vincoli. Condividi il tuo codice e
                  guadagni 97€ per ogni attività che si iscrive.
                </p>
              </div>
            </div>

            <div className="mt-6 grid gap-4 sm:grid-cols-3">
              {STEPS.map((s, i) => (
                <div
                  key={s.title}
                  data-testid={`partner-step-${i}`}
                  className="rounded-3xl bg-purple-50/70 p-5 text-center"
                >
                  <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-purple-600 text-white">
                    <s.icon className="h-5 w-5" />
                  </span>
                  <p className="mt-3 font-heading text-sm font-bold text-slate-900">
                    {i + 1}. {s.title}
                  </p>
                  <p className="mt-1 text-xs leading-relaxed text-slate-500">{s.text}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <a
                data-testid="partner-cta-link"
                href="https://app.miria.one/partner"
                target="_blank"
                rel="noopener noreferrer"
                className="cta-pulse inline-flex items-center justify-center gap-2 rounded-full bg-purple-600 px-8 py-4 font-heading text-base font-bold text-white transition-[transform,background-color] duration-300 hover:scale-[1.04] hover:bg-purple-700"
              >
                Diventa partner — è gratis
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
